import { b2bAddressesApi } from '../b2b/addresses';
import { b2cAddressesApi } from '../b2c/addresses';
import { B2B_ADDRESSES_PATH, B2C_ADDRESSES_PATH, ZIP_CODE_PATH, } from '../../constants/links';
import { apiB2B, apiB2C, apiBase } from '../axios-client';
import { mapAddressListToCommonModel } from '../../utils/mapping-addresses';
import { ERROR_CODES } from '../../constants/custom-errors';
import { ADDRESSES_PAGE_SIZE } from '../../constants/general';
const handleAddressesResponse = (data) => {
    var _a;
    const addresses = (_a = data.addresses) === null || _a === void 0 ? void 0 : _a.address;
    const paginationInfo = data.paginationInfo;
    const totalNumberOfAddresses = paginationInfo === null || paginationInfo === void 0 ? void 0 : paginationInfo.totalNumberOfRecords;
    if (Array.isArray(addresses) && addresses.length > 0) {
        return mapAddressListToCommonModel(addresses, paginationInfo);
    }
    if (!Number(totalNumberOfAddresses)) {
        throw new Error(ERROR_CODES.NO_SAVED_ADR_CODE);
    }
    throw new Error(ERROR_CODES.NO_FOUND_ADR_CODE);
};
export const addressesApi = {
    getAddresses: (isB2B, { page, sortBy, ascendingOrder, pageSize }) => {
        if (isB2B) {
            return apiB2B
                .get(B2B_ADDRESSES_PATH, {
                params: {
                    ps: ADDRESSES_PAGE_SIZE,
                    pn: page || 1,
                    sb: sortBy || 'lastedited',
                    asc: ascendingOrder || false,
                },
            })
                .then(({ data }) => handleAddressesResponse(data));
        }
        return apiB2C
            .get(B2C_ADDRESSES_PATH, {
            params: {
                pageSize: typeof pageSize === 'number' ? pageSize : ADDRESSES_PAGE_SIZE,
                pageNumber: typeof page === 'number' ? page : 1,
            },
        })
            .then(({ data }) => handleAddressesResponse(data));
    },
    deleteAddress: (isB2B, { addrIdentifier, userId, lastModifiedDate }) => {
        if (isB2B) {
            return b2bAddressesApi.deleteAddress({ addrIdentifier, userId });
        }
        return b2cAddressesApi.deleteAddress({ addrIdentifier, lastModifiedDate });
    },
    changeDefaultAddress: (isB2B, newDefaultRequestData, oldDefaultRequestData) => {
        if (isB2B) {
            return b2bAddressesApi.editAddress(newDefaultRequestData).then((data) => {
                const newDefaultAdr = data.addresses.address.find((adr) => adr.isDefault);
                if (!newDefaultAdr) {
                    throw new Error('Default address not set');
                }
                return newDefaultAdr;
            });
        }
        return b2cAddressesApi
            .editAddress(...[newDefaultRequestData, oldDefaultRequestData].filter((value) => Boolean(value)))
            .then((data) => {
            const newDefaultAdr = data.addresses.address.find((adr) => adr.isDefault);
            if (!newDefaultAdr) {
                throw new Error('Default address not set');
            }
            return newDefaultAdr;
        });
    },
    getPostalList: (code) => apiBase.get(`${ZIP_CODE_PATH}/${code}`).then(({ data }) => {
        var _a;
        if (data && ((_a = data.postalDetailsList) === null || _a === void 0 ? void 0 : _a.length) > 0) {
            return data.postalDetailsList;
        }
        throw new Error('postalDetailsList is empty');
    }),
    addNewAddress: (isB2B, requestData) => {
        if (isB2B) {
            return b2bAddressesApi.addNewAddress(requestData);
        }
        return b2cAddressesApi.addNewAddress(requestData);
    },
    editAddress: (isB2B, requestData) => {
        if (isB2B) {
            return b2bAddressesApi.editAddress(requestData);
        }
        return b2cAddressesApi.editAddress(requestData);
    },
};
